export class User {
    public email: string;
    public password: string;

    constructor() {
    }

}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/model/user.model.ts